export * from "./Arrow-right-line"
export * from "./ArrowDownLine"
export * from "./ArrowRightLine"
export * from "./ArrowUpLine"
export * from "./Building"
export * from "./ChevronLeft"
export * from "./ChevronRight"
export * from "./CircleCheck"
export * from "./Close"
export * from "./Copy"
export * from "./Disquette"
export * from "./Download-line"
export * from "./Edit-2-fill"
export * from "./IconeLogo"
export * from "./Info-circle"
export * from "./BarberGuy"
export * from "./LockFill"
export * from "./Map-pin-2-fill"
export * from "./MenuFill"
export * from "./Minus"
export * from "./OctogoneCross"
export * from "./Parametre"
export * from "./Plus"
export * from "./SearchLine"
export * from "./SuccessCircle"
export * from "./Warning"
